<div class="row">
  <div class="col-md-12">
    <fui-heading [text]="'account.account_notifications' | translate" [level]="5"></fui-heading>
    <p>{{ "account.manage_notifications" | translate }}</p>
    @if (!user.push_token) {
      <div class="m-y-20 c-gray">
        <p>{{ "account.indicates_mandatory_fields" | translate }}</p>
        <img src="./assets/images/mypresonus-app-icon.png" style="height: 50px; display: inline-block" alt="MyPreSonus app logo" />
        &nbsp;&nbsp;
        <a href="https://apps.apple.com/us/app/mypresonus/id1282534772" target="_blank">
          <img src="./assets/images/download-on-the-app-store.png" style="height: 50px; display: inline-block" alt="Download on the App Store" />
        </a>
        &nbsp;&nbsp;
        <a href="https://play.google.com/store/apps/details?id=com.presonus.mypresonus&hl=en_US&gl=US" target="_blank">
          <img src="./assets/images/download-on-the-play-store.png" style="height: 50px; display: inline-block" alt="Get it on Google Play" />
        </a>
        &nbsp;&nbsp;
      </div>
    }
    <div class="m-t-50">
      <fieldset class="m-y-20">
        @for (topic of notificationTopics; track topic) {
          <div class="m-b-30">
            <fui-heading [text]="topic.title" [level]="6"></fui-heading>
            {{ topic.description }}
            <br />
            @for (client of clients; track client) {
              <div class="d-block">
                <myp-switch
                  [active]="topic.clients[client.id]"
                  [label]="client.title"
                  [labelToRight]="true"
                  (toggle)="topic.topic === 'beta_community' ? onBetaCommunityChannelToggle(topic, client.id) : (topic.clients[client.id] = !topic.clients[client.id])"
                  extraClasses="m-b-10"
                ></myp-switch>
              </div>
            }
            @if (topic.topic == "collaboration" && !topic.clients.email && !topic.clients.mobile) {
              <div class="t-14">
                <p>{{ "account.collaboration_warning" | translate }}</p>
              </div>
            }
            @if (topic.topic == "collaboration" && (topic.clients.email || topic.clients.mobile)) {
              <div class="t-12 c-gray">
                <p>{{ "account.mobile_notification_info" | translate }}</p>
              </div>
            }
          </div>
        }

        @if (!loadingReminders && eventReminders.length) {
          <div class="m-t-50 m-b-50">
            <fui-heading [text]="'Event Reminders'" [level]="5"></fui-heading>
            Events you've asked to be reminded about.
            <br />
            <br />
            @if (loadingReminders) {
              <p style="opacity: 0.7">Loading…</p>
            } @else {
              @for (reminder of eventReminders; track reminder.slug) {
                <div class="d-flex align-items-center justify-content-between m-b-15 p-b-15" style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)">
                  <div class="d-flex align-items-center">
                    @if (reminder.image_url) {
                      <img [src]="reminder.image_url" class="m-r-15" style="width: 48px; height: 48px; object-fit: cover; border-radius: 6px" />
                    }
                    <div>
                      <div class="fui-heading-font t-16">{{ reminder.title }}</div>
                      <div style="opacity: 0.7; font-size: 13px">{{ reminder.whenLabel }}</div>
                    </div>
                  </div>
                  <button class="btn btn-transparent" (click)="removeEventReminder(reminder)">Remove Reminder</button>
                </div>
              }
            }
          </div>
        }

        @if (showBetaTopics) {
          <div class="m-b-30">
            <fui-heading [text]="'account.beta_programs_activity' | translate" [level]="5"></fui-heading>
            <p>{{ "account.beta_participant_info" | translate }}</p>
            <p>{{ "account.beta_notification_info" | translate }}</p>
            @for (betaStringId of this.betaService.enrolledBetas; track betaStringId) {
              <div class="m-b-20">
                <span class="fui-heading-font">{{ betaService.betaDetailByStringId[betaStringId].title }}</span>
                <myp-switch
                  [active]="betaCommunityNotificationPreferences[betaStringId].new"
                  [label]="'account.adds_a_post' | translate"
                  [labelToRight]="true"
                  [disabled]="betaCommunityChannelsAllOff"
                  (toggle)="betaCommunityNotificationPreferences[betaStringId].new = !betaCommunityNotificationPreferences[betaStringId].new"
                  extraClasses="m-b-10"
                ></myp-switch>
                <myp-switch
                  [active]="betaCommunityNotificationPreferences[betaStringId].relevant_replies"
                  [label]="'account.replies_on_authored_post' | translate"
                  [labelToRight]="true"
                  [disabled]="betaCommunityChannelsAllOff"
                  (toggle)="betaCommunityNotificationPreferences[betaStringId].relevant_replies = !betaCommunityNotificationPreferences[betaStringId].relevant_replies"
                  extraClasses="m-b-10"
                ></myp-switch>
                <myp-switch
                  [active]="betaCommunityNotificationPreferences[betaStringId].all_replies"
                  [label]="'account.replies_to_any_post' | translate"
                  [labelToRight]="true"
                  [disabled]="betaCommunityChannelsAllOff"
                  (toggle)="betaCommunityNotificationPreferences[betaStringId].all_replies = !betaCommunityNotificationPreferences[betaStringId].all_replies"
                  extraClasses="m-b-10"
                ></myp-switch>
              </div>
            }
          </div>
        }
        <br />
      </fieldset>
    </div>
    <button class="btn btn-secondary m-b-20" (click)="save()">
      <fa-icon icon="check"></fa-icon>
      &nbsp;{{ "general.save" | translate }}
    </button>
  </div>
</div>
